import * as React from 'react'
import { observer } from 'mobx-react'
import { TextInputContainer } from 'components/inputs'
import NameInputViewModel from 'jobs/creation/NameViewModel'

interface CompactNameInputProps {
  vm: NameInputViewModel
}

export default observer(function CompactNameInput({
  vm,
}: CompactNameInputProps) {
  return (
    <TextInputContainer
      model={vm}
      field="name"
      name="name"
      placeholder="Customize the job's name. Optional."
      data-test="compact-name-input"
      disabled={vm.disabled}
      onFocus={vm.step.onBecameActive}
      focus$={vm.step.becomeActive$}
      onBlur={(e) => {
        const value = (e.target as HTMLInputElement).value
        vm.rename(value.trim())
      }}
    />
  )
})
